export default __webpack_public_path__ + "static/media/Trovitylogo.033c7a9b.svg";